var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ClientOnly',[(_vm.showCaptcha)?_c('div',{staticClass:"g-recaptcha mt-4 mb-4",attrs:{"id":_vm.containerId}}):_vm._e()]),_vm._v(" "),_vm._t("default",null,{"props":{recaptchaOk: _vm.recaptchaClicked, expiredCallback: _vm.expiredCallback}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }